<div class="">
  <h2 *ngIf="showTitle" class="text-center">
    Configuración Banco de Preguntas
  </h2>

  <div
    class="my-3 d-flex flex-column flex-sm-row align-items-center justify-content-between w-100"
  >
    <div *ngIf="showFilters" class="d-flex flex-column flex-sm-row align-items-center w-100" style="flex:10;">
      <mat-form-field style="width: 100%">
        <mat-label>Buscar pregunta</mat-label>
        <input
          matInput
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterQuestions()"
          placeholder="Buscar"
        />
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Filtrar por tipo de respuesta</mat-label>
        <mat-select
          [(ngModel)]="selectedResponseType"
          (selectionChange)="filterQuestions()"
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option
            *ngFor="let type of responseType"
            [value]="type.responseType"
          >
            {{ type.responseType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    
    <div class="d-flex flex-row justify-content-around gap-1 w-100" style="flex:2;">
      <button
        matTooltip="Guardar cambios"
        matTooltipPosition="above"
        mat-mini-fab
        color="warn"
        (click)="saveOrder()"
        [style.visibility]="
          bodyQuestions?.length > 0 && positionChange ? 'visible' : 'hidden'
        "
      >
        <mat-icon>save</mat-icon>
      </button>

      <button
        matTooltip="Descargar formato actual"
        matTooltipPosition="above"
        mat-mini-fab
        color="accent"
        (click)="getFormAccordingToVersion($event)"
        *ngIf="bodyQuestions?.length > 0 && !questionsBank"
      >
        <mat-icon>file_download</mat-icon>
      </button>

      <button
        *ngIf="addQuestion"
        matTooltip="Agregar pregunta"
        matTooltipPosition="above"
        mat-mini-fab
        color="primary"
        (click)="addNewQuestion($event)"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>

  </div>

  <mat-accordion
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    class="example-headers-align panel my"
  >
    <mat-expansion-panel
      class="panel"
      class="mb-3"
      *ngFor="let data of filteredQuestions; let i = index"
      cdkDrag
      [cdkDragDisabled]="!cdkDragEnabled"
      [expanded]="data.questionId == questionId"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="title" style="align-items: center">
          <h5 class="no-spacing">
            {{data.question}}
          </h5>
        </mat-panel-title>
        <mat-panel-description style="display: flex; justify-content: flex-end">
          <mat-icon
            *ngIf="questionsBank"
            class="m-2"
            matTooltip="Editar pregunta"
            matTooltipPosition="above"
            color="primary"
            (click)="editQuestion(data)"
            >edit</mat-icon
          >
          <mat-icon
            class="m-2"
            matTooltip="Eliminar pregunta"
            matTooltipPosition="above"
            color="warn"
            (click)="deleteQuestion(data)"
            >delete</mat-icon
          >
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div
        style="
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          width: 100%;
        "
      >
        <div
          style="width: 100%"
          class="first-row"
          *ngIf="data?.responses?.length == 1"
        >
          <div
            *ngIf="data?.responses[0] == 'Texto'"
            class="row-item"
            style="display: flex; flex-direction: row"
          >
            <mat-form-field>
              <input
                autocomplete="off"
                type="text"
                matInput
                required
                #descripcion
                maxlength="255"
              />
              <mat-hint>{{ descripcion.value.length }}/255</mat-hint>
            </mat-form-field>
            <button
              style="margin: 0 10px 0 10px; width: 90px; height: 5%"
              mat-raised-button
            >
              Enviar
            </button>
          </div>

          <div
            *ngIf="data?.responses[0] == 'Numero'"
            class="row-item"
            style="display: flex; flex-direction: row"
          >
            <mat-form-field>
              <input
                autocomplete="off"
                type="number"
                matInput
                required
                #descripcion
                oninput="this.value = this.value.slice(0,7)"
              />
              <mat-hint>{{ descripcion.value.length }}/7</mat-hint>
            </mat-form-field>
            <button
              style="margin: 0 10px 0 10px; width: 90px; height: 5%"
              mat-raised-button
            >
              Enviar
            </button>
          </div>

          <div
            *ngIf="data?.responses[0] == 'Fecha'"
            class="row-item"
            style="display: flex; flex-direction: center; width: 100%"
          >
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="pickerFecha"
                autocomplete="off"
                required
                placeholder="Seleccione una fecha"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerFecha"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerFecha></mat-datepicker>
            </mat-form-field>
          </div>

          <div
            *ngIf="data?.responses[0] == 'Imagen'"
            class="row-item"
            style="display: flex; flex-direction: column; width: 100%"
          >
            <div class="containerPhotos">
              <file-input
                [params]="fileInput"
              ></file-input>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 10px;">
              <button
                style="width: 90px; height: 5%"
                mat-raised-button
              >
                Enviar
              </button>
            </div>
          </div>
        </div>

        <div *ngFor="let res of data.responses; let j = index">
          <button
            *ngIf="data.responses.length > 1"
            class="button-response"
            mat-raised-button
          >
            {{ res }}
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
